export class Order {

    orderItems: any[] = [];
    selectedProducts: any[] = [];
    files: any[] = [];
    params: any[] = [];
    trialDays = null;
    hscontext = '';
    hsFormId = '';
    paymentMethod: any = {};
    dfFormId = '';
    mode = '';
    url = '';
    invoiceFooter = null;
    redirect = null;
    customDealProperties = {};
    recaptchaTokenV3 = '';
    recaptchaTokenV2 = '';
    hubSpotDealId = '';

}
